import React, { Fragment } from "react";
import connect from "./connect";
import { FormattedMessage } from "react-intl";
import ExistingUser from "./ExistingUser";
import NewUser from "./NewUser";
import Wrapper from "./Wrapper";
import "./Login.less";
import LoginNotice from "./LoginNotice/LoginNotice";
import track from "react-tracking";
const Login = (props) => (<Fragment>
		<LoginNotice />
		<Wrapper {...props}>
			<NewUser {...props}>
				<div className="vr vr_x4">
					<div className="text">
						<p>
							<FormattedMessage id="login.newUser.message" defaultMessage={"Welcome to DCMS ServiceLink®. If this is your first time accessing "
    + "DCMS ServiceLink®, please proceed using the Reference/File Number and PIN below."}/>
						</p>
					</div>
				</div>
			</NewUser>

			<div className="vr vr_x5 hr-vr">
				<div className="hr mix-hr_wide"/>
			</div>

			<ExistingUser {...props}>
				<div className="vr vr_x4">
					<div className="text">
						<p>
							<FormattedMessage id="login.existingUser.message" defaultMessage={"If you already have a DCMS ServiceLink® login, please login here. "
    + "Once logged in, you will be able to load additional reference/file "
    + "numbers to your profile."}/>
						</p>
					</div>
				</div>
			</ExistingUser>
			<div style={{ paddingLeft: "20px", paddingRight: "20px", marginTop: "33px" }}>
				{process.env.CLIENT !== "CapOne" && (<div style={{ paddingBottom: "25px", textAlign: "center" }}>
						<FormattedMessage id="notice.miniMiranda" defaultMessage="DCM Services is a debt collection agency attempting to collect a debt. Any information obtained will be used for that purpose."/>
					</div>)}
				<div style={{ paddingBottom: "8px", fontWeight: 600, textAlign: "center" }}>
					<FormattedMessage tagName="h2" id="notice.languageServices.title" defaultMessage="For New York City Residents"/>
				</div>

				<FormattedMessage id="notice.languageServices" defaultMessage={"DCM Services does not offer language access services.  However, we do offer translation of verbal and written communications into Spanish but on a limited basis. Translation and description of common debt collection terms is available in multiple languages on the Department of Consumer Affairs website, {link}."} values={{
    link: <a className="link" href="http://www.nyc.gov/dca">www.nyc.gov/dca</a>
}}/>
			</div>
		</Wrapper>
	</Fragment>);
/* Create and export container component that wraps Login for property binding */
export default track({ page: "Login" }, { dispatchOnMount: true })(connect(Login));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/Login.tsx